export const AUTH_CONT = 'auth_cont';
export const AUTH_CONT_URL = `/${AUTH_CONT}`;
export const AUTH_CONT_KEY_EMPLOYEE = 'employee';
export const AUTH_CONT_KEY_OKTA = 'okta';

export const LOGIN_ROUTE_PATH = 'login';
export const TARGET_URI = 'targetUri';
export const FORGOT_PASSWORD_LINK = '/register/forgot_password';
